import { render, staticRenderFns } from "./archivesRecommend.vue?vue&type=template&id=3f3710a9&scoped=true&"
import script from "./archivesRecommend.vue?vue&type=script&lang=js&"
export * from "./archivesRecommend.vue?vue&type=script&lang=js&"
import style0 from "./archivesRecommend.vue?vue&type=style&index=0&id=3f3710a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3710a9",
  null
  
)

export default component.exports